const Services = () => {
  return (
    <div className="Pages">
      <h1>Services</h1>

      We offer the following services:
      <h2>Financial Planning</h2>
      <ol>
        <li>
          <b>Comprehensive Financial Planning:</b> Develop detailed financial plans that cover all aspects of a client’s financial life, including budgeting, saving, investing, and retirement planning.
        </li>
        <li>
          <b>Retirement Planning:</b> Help clients create strategies to achieve their retirement goals, including estimating retirement income needs and selecting appropriate retirement accounts.
        </li>
      </ol>
      <h2>Budgeting and Saving</h2>
      <ol>
        <li>
          <b>Budget Creation and Management:</b> Assist clients in creating and maintaining a budget that aligns with their financial goals.
        </li>
        <li>
          <b>Savings Strategies:</b> Provide guidance on building emergency funds, saving for specific goals, and optimizing savings accounts.
        </li>
      </ol>
      <h2>Debt Management</h2>
      <ol>
        <li>
          <b>Debt Reduction Plans:</b> Develop personalized plans to help clients pay off debt efficiently, including strategies like the debt snowball or debt avalanche methods.
        </li>
        <li><b>Credit Score Improvement: Offer advice on improving credit scores and managing credit responsibly.</b></li>
      </ol>
      <h2>Investment Guidance</h2>
      <ol>
        <li>
          <b>Basic Investment Education:</b> Educate clients on investment principles and strategies, including risk tolerance and asset allocation.</li>
        <li>
          <b>Portfolio Review:</b> Review and provide feedback on clients’ existing investment portfolios.</li>
      </ol>

      <h2>Insurance Planning</h2>
      <ol>
        <li>
          <b>Insurance Needs Analysis:</b> Assess clients’ insurance needs and recommend appropriate coverage, including life, health, disability, and long - term care insurance.
        </li></ol>
      <h2>Specialized Services</h2>
      <ol>
        <li>
          <b>College Planning:</b> Assist families in planning and saving for college expenses.</li></ol>

      <h2>Ongoing Support and Accountability</h2>
      <ol>
        <li><b>Regular Check - Ins:</b> Schedule regular meetings with clients to review progress and make adjustments to their financial plans.</li>
        <li><b>Accountability Partner:</b> Act as an accountability partner to help clients stay on track with their financial goals.</li>
      </ol>

    </div>
  );
};

export default Services;
